<template lang="html">
  <component :is="tag" class="text__medium" :class="{ bold: bold }">
    <!-- @slot Безымянный слот. Используется для вставки текста-->
    <slot/>
  </component>
</template>

<script>
export default {
  name: 'bimTextMedium',
  props: {
    /**
     * Добавить жирность
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Тег обёртки
     */
    tag: {
      type: String,
      default: 'div'
    },
    /**
     * Изменять размер шрифта в моб версии
     * @values true, false
     */
    adaptive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.text__medium {
  font-size: 14px;
  font-weight: normal;
  line-height: 1.36;
  letter-spacing: normal;
}

.text__medium.bold {
  font-weight: bold;
}
</style>
